import { render, staticRenderFns } from "./ViewGalleries.vue?vue&type=template&id=13d2aa62&"
import script from "./ViewGalleries.vue?vue&type=script&lang=ts&"
export * from "./ViewGalleries.vue?vue&type=script&lang=ts&"
import style0 from "./ViewGalleries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
